import { FetchResourceCollectionOK } from '@/japi/types/FetchResourceCollectionOK'
import { Resource } from '@/japi/types/Resource'

import { isErrorDocument } from './isErrorDocument'

export const isResourceCollectionDocument = <R extends Resource>(japiDocument: any): japiDocument is FetchResourceCollectionOK<R> => typeof japiDocument === 'object' && japiDocument !== null && ! isErrorDocument(japiDocument) && Array.isArray(japiDocument.data) // eslint-disable-line
